import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';

import Display from './Display';
import { formatAddress, formatContact } from '../helpers/formatData';

const Amendment = ({
  title = 'Order Details',
  taskData: {
    amendmentType: type,
    amendmentDescription: description,
    name,
    physicalAddress,
    mailingAddress,
    principalAddress,
    purpose,
    managerType,
    managers,
    members,
    directors,
    officers,
    signatory,
    authorizedShares,
    parValue
  } = {},
  onClose
}) => {
  const { formatMessage: fm } = useIntl();

  const addresses = [
    {
      label: fm({ id: 'orderView.items.physicalAddress' }),
      content: physicalAddress ? formatAddress(physicalAddress, fm) : fm({ id: 'orderView.items.none' }),
      xs: 12,
      md: 6
    },
    {
      label: fm({ id: 'orderView.items.mailingAddress' }),
      content: mailingAddress ? formatAddress(mailingAddress, fm) : fm({ id: 'orderView.items.none' }),
      xs: 12,
      md: 6
    },
    {
      label: fm({ id: 'orderView.items.principalAddress' }),
      content: principalAddress ? formatAddress(principalAddress, fm) : fm({ id: 'orderView.items.none' }),
      xs: 12,
      md: 6
    }
  ].filter(({ content }) => content !== fm({ id: 'orderView.items.none' }));

  const dataSections = [
    {
      title: fm({ id: 'orderView.items.amendmentType' }),
      filter: !!type,
      items: [{ content: type, xs: 12 }]
    },
    {
      title: fm({ id: 'orderView.items.description' }),
      filter: !!description,
      items: [{ content: description, xs: 12 }]
    },
    {
      title: fm({ id: 'orderView.items.businessName' }),
      filter: !!name,
      items: [{ content: name, xs: 12 }]
    },
    {
      title: fm({ id: 'orderView.items.addresses' }),
      filter: addresses.length > 0,
      items: addresses
    },
    {
      title: fm({ id: 'orderView.items.businessPurpose' }),
      filter: !!purpose,
      items: [{ content: purpose, xs: 12 }]
    },
    {
      title: fm({ id: 'orderView.items.structure' }),
      filter: !!managerType,
      items: [{ content: managerType, xs: 12 }]
    },
    {
      title: fm({ id: 'orderView.items.managers' }),
      filter: managers !== null && managers !== undefined && managers.length !== 0,
      items:
        managers
        && managers.map((manager) => ({
          content: formatContact(manager, fm),
          xs: 12,
          md: 6
        }))
    },
    {
      title: fm({ id: 'orderView.items.members' }),
      filter: members !== null && members !== undefined && members.length !== 0,
      items:
        members
        && members.map((member) => ({
          content: formatContact(member, fm),
          xs: 12
        }))
    },
    {
      title: fm({ id: 'orderView.items.directors' }),
      filter: directors !== null && directors !== undefined && directors.length !== 0,
      items:
        directors
        && directors.map((director) => ({
          content: formatContact(director, fm),
          xs: 12,
          md: 6
        }))
    },
    {
      title: fm({ id: 'orderView.items.officers' }),
      filter: officers !== null && officers !== undefined && officers.length !== 0,
      items:
        officers
        && officers.map((officer) => ({
          content: formatContact(officer, fm),
          xs: 12
        }))
    },
    {
      title: fm({ id: 'orderView.items.authorizedShares' }),
      filter: !!authorizedShares,
      items: [{ content: authorizedShares, xs: 12 }]
    },
    {
      title: fm({ id: 'orderView.items.parValuePerShare' }),
      filter: !!parValue,
      items: [{ content: parValue, xs: 12 }]
    },
    {
      title: fm({ id: 'orderView.items.authorizedSignatory' }),
      filter: !!signatory,
      items: [{ content: formatContact(signatory, fm), xs: 12 }]
    }
  ].filter(({ filter }) => filter !== false);

  const defaultMessage = [
    {
      items: [{ content: fm({ id: 'orderView.items.amendmentOrdered' }) }]
    }
  ];

  const sections = dataSections.length > 0 ? dataSections : defaultMessage;

  return (
    <Display
      onClose={onClose}
      sections={sections}
      title={title}
    />
  );
};

Amendment.propTypes = {
  title: PropTypes.string,
  taskData: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired
};

export default Amendment;
